import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useCheckinContext } from '../contexts/CheckinContext'

function NavItem({ to, label, icon, badgeCount }) {
  const location = useLocation()
  const isActive = location.pathname === to

  return (
    <Link
      to={to}
      className={`
        flex flex-col items-center justify-center gap-1 flex-1 py-2 relative
        transition-colors duration-150 min-h-[44px]
        ${isActive
          ? 'text-amber-500'
          : 'text-stone-400 dark:text-stone-500 hover:text-stone-600 dark:hover:text-stone-300'
        }
      `}
      aria-current={isActive ? 'page' : undefined}
    >
      <div className="relative">
        <span className="text-2xl leading-none">{icon}</span>
        {badgeCount > 0 && (
          <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center leading-none">
            {badgeCount > 9 ? '9+' : badgeCount}
          </span>
        )}
      </div>
      <span className={`text-[10px] font-medium leading-none ${isActive ? 'text-amber-500' : ''}`}>
        {label}
      </span>
    </Link>
  )
}

export function Layout({ children }) {
  const { user } = useAuth()
  const { pendingCount } = useCheckinContext()

  return (
    <div className="flex flex-col min-h-[100dvh]">
      {/* Page content */}
      <main className="flex-1 overflow-y-auto">
        {children}
      </main>

      {/* Bottom nav — only when authenticated */}
      {user && (
        <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-stone-900 border-t border-stone-200 dark:border-stone-800 safe-bottom z-30">
          <div className="flex items-stretch max-w-lg mx-auto">
            <NavItem to="/dashboard" label="Home" icon="🏠" badgeCount={pendingCount} />
            <NavItem to="/circle" label="Circle" icon="👥" />
            <NavItem to="/profile" label="Profile" icon="👤" />
          </div>
        </nav>
      )}
    </div>
  )
}

export default Layout
